import { memoize } from "lodash";
import { computed, observable, runInAction } from "mobx";
import { TEt3PickerSingleValue } from "../../../TypesNEW";
import i18n from "../../../constants/i18n";
import { getSpecificDateWithDays } from "../../../core/et3-date";
import { reducerToZeroIfUndefined } from "../../../helpers/et3-picker-data-helper";
import { isPositiveNumber } from "et3-type-guards";
import getCoreUIStore from "../../core/core-ui-store";
import { apiCallGetAuditorEventsData } from "../../../api/auditor-api/api-call-get-auditors-events-data";
import getCorePopUpStore from "../../core/core-popup-store";
import { TAuditorEventsData } from "../../../Types";

class AuditorsEventsStore {
  auditorEventsData = observable.box<TAuditorEventsData>([]);
  auditorInput = observable.box<TEt3PickerSingleValue>({
    value: "",
    label: i18n.get("CHOOSE")
  });
  dateMinInput = observable.box<Date>(
    getSpecificDateWithDays({ daysSubtracted: 1, daysAdded: 0 })
  );
  dateMaxInput = observable.box<Date>(
    getSpecificDateWithDays({ daysSubtracted: 0, daysAdded: 1 })
  );

  isGetButtonEnabled = computed(() => {
    const definedAuditorID = reducerToZeroIfUndefined(
      parseInt(this.auditorInput.get().value, 10)
    );
    const isEnabled = isPositiveNumber(definedAuditorID);

    return isEnabled;
  });

  setAuditorInput = ({ auditor }: { auditor: TEt3PickerSingleValue }) => {
    runInAction(() => {
      this.auditorInput.set(auditor);
    });
  };

  setAuditorEventsData = (eventsData: TAuditorEventsData) => {
    runInAction(() => {
      this.auditorEventsData.set(eventsData);
    });
  };

  getAuditorEventsData = async () => {
    const definedAuditorID = reducerToZeroIfUndefined(
      parseInt(this.auditorInput.get().value, 10)
    );
    if (!isPositiveNumber(definedAuditorID)) {
      return;
    }
    getCoreUIStore().setIsLoading("AUDITOR_AUDIT", true);

    const { data, status, code } = await apiCallGetAuditorEventsData({
      auditorID: definedAuditorID,
      dateMin: this.dateMinInput.get(),
      dateMax: this.dateMaxInput.get()
    });

    if (status === "OK") {
      this.setAuditorEventsData(data);
    } else {
      getCorePopUpStore().showAlertMessage(code);
    }

    getCoreUIStore().setIsLoading("AUDITOR_AUDIT", false);
  };
}

const getAuditorsEventsStore = memoize(
  () => new AuditorsEventsStore(),
  () => 1
);
export default getAuditorsEventsStore;
